module.exports = __webpack_public_path__ + "static/media/info.04618d9f.svg";